import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { useLocation, useNavigate } from 'react-router-dom';
import "../pagination/pagination.css"
import Pagination from '../pagination/pagination';
import Select from 'react-select';
import { RiRefreshLine } from "react-icons/ri";
import { FaFileCircleExclamation } from "react-icons/fa6";
import LeaseApiService from '../../services/apiService';
import './dashboard.css'
const REPORT_URL = process.env.REACT_APP_REPORTS_URL
const ListingDashBoard = () => {
    const [rowData, setRowData] = useState([]);
    const [proprtyList, setProperty] = useState([]);
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [unitList, setUnitList] = useState([])
    const apiService = new LeaseApiService();
    const [FilterTab, setFilterTab] = useState(true);
    const [permissions, setPermissions] = useState([]);
    const [contextMenu, setContextMenu] = useState(null);
    const location = useLocation();
    const leaseData = location.state;
    let navigate = useNavigate()
    const [formData, setFormData] = useState({
        Proprty: [{ label: 'Select Property', value: '' }],
        unitNo: [{ label: 'Select Unit No', value: '' }],
        TanantName: [{ label: 'Select Tenant', value: '' }],
        leaseNo: [{ label: 'Select Lease No', value: '' }],
        status: [{ label: 'All', value: '' }],
        periodFrom: '',
        periodto: '',
    });
    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);
    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, []);
    useEffect(() => {
        fetchDropdownData()
        getItems()
    }, []);
    const fetchDropdownData = async () => {
        try {
            const params = new URLSearchParams();
            params.append('dropdownTypes', 'DashboardSearchPropertyNos');
            const res = await apiService.getApiParamater('GET_DASHBOARD_DROP', `?${params.toString()}`);
            setProperty([{ value: 'All', text: 'All' }, ...res?.data?.dropdowns?.PropertyNo]);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    }
    const handleLeaseReceipt = (rowData) => {
        navigate(`/Property/Management/Lease/Receipt/${rowData?.leaseNo}`, { state: rowData });
    }
    const handleCreateAgreement = (rowData) => {
        navigate(`/Property/Management/LeaseAgreement/Dash/${rowData?.unitNo}`, { state: rowData });
    }
    const getItems = async () => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Leaseno', formData?.leaseNo?.label || 'All');
            params.append('TenantNo', formData?.TanantName?.value?.value || 'All');
            params.append('Status', formData?.status?.label || 'All');
            params.append('DashboardFilter', leaseData === 1 ? 'All' :
                leaseData === 2 ? "Available" : leaseData === 3 ? "Active" : leaseData === 5 ? "Leased" :
                    leaseData === 11 ? "PendingRenewal" : leaseData === 6 ? "Renewed" : leaseData === 7 ? "Terminated" : leaseData === 8 ? "Expiryin30Days" :
                        leaseData === 9 ? "Expiryin60Days" : leaseData === 10 ? "Expiryin90Days" : leaseData?.propertyName ? "ExpiringLeases" :
                            leaseData === 15 ? "PMTotal" : leaseData === 14 ? "LeaseTotal" : leaseData === 4 ? "Blocked" : "");
            params.append('PeriodFrom', formData?.periodFrom);
            params.append('PeriodTo', formData?.periodto);
            const res = await apiService.getApiParamater('GET_DASHBOARD_LIST', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData);
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const SearchItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 50);
            params.append('PropertyNo', formData?.Proprty?.value?.value || 'All');
            params.append('UnitNo', formData?.unitNo?.label || 'All');
            params.append('Leaseno', formData?.leaseNo?.label || 'All');
            params.append('TenantNo', formData?.TanantName?.label || 'All');
            params.append('Status', formData?.status?.label || 'All');
            params.append('PeriodFrom', formData?.periodFrom);
            params.append('PeriodTo', formData?.periodto);
            params.append('DashboardFilter', leaseData === 1 ? 'All' :
                leaseData === 2 ? "Available" : leaseData === 3 ? "Active" : leaseData === 5 ? "Leased" :
                    leaseData === 11 ? "PendingRenewal" : leaseData === 6 ? "Renewed" : leaseData === 7 ? "Terminated" : leaseData === 8 ? "Expiryin30Days" :
                        leaseData === 9 ? "Expiryin60Days" : leaseData === 10 ? "Expiryin90Days" : leaseData?.propertyName ? "ExpiringLeases" :
                            leaseData === 15 ? "PMTotal" : leaseData === 14 ? "LeaseTotal" : leaseData === 4 ? "Blocked" : "");
            const res = await apiService.getApiParamater('GET_DASHBOARD_LIST', `?${params.toString()}`);
            setRowData(res?.data?.result || []);
            setPagination(res.data.paginationData); 
        } catch (error) {
            console.error('Error fetching items:', error);
        }
    }
    const numberValueFormatter = function (params) {
        return params?.value;
    }
    const columnDefs = [
        {
            headerName: '', field: 'unitStatus', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },
        {
            headerName: 'Property Name', field: 'propertyName', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 200
        },
        {
            headerName: 'Unit No', field: 'unitNo', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 100
        },
        {
            headerName: 'Lease No', field: 'leaseNo', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 110
        },
        {
            headerName: 'Unit Status', field: 'unitStatus', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 130
        },
        {
            headerName: 'Lease Status', field: 'leaseStatus', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 150
        },
        // {
        //     headerName: 'Owner No', field: 'sellerNo',
        //     valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100
        // },
        {
            headerName: 'Unit Class', field: 'unitClass', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 110
        },
        {
            headerName: 'Unit Model', field: 'unitModel', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 110
        },
        {
            headerName: 'Unit Category', field: 'unitCategory', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 130
        },
        {
            headerName: 'Balcony', field: 'balcony', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 100
        },
        {
            headerName: 'Facilities', field: 'facilities', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 110
        },
        {
            headerName: 'Rent Per Day', field: 'rentPerDay',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 120
        },
        {
            headerName: 'Rent Per Anum', field: 'rentPerAnnum',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 130
        },
        {
            headerName: 'Rent PI', field: 'rentPI',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 100
        },
        {
            headerName: 'Lease From', field: 'leaseDate', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 110,
        }, {
            headerName: 'Lease To', field: 'leaseExpiry', filter: true,
            floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 110,
        },
        {
            headerName: 'Total Price', field: 'totalPriceByUser',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 110
        },
        {
            headerName: 'Tenant Name', field: 'custName', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 200
        },
        {
            headerName: 'Tenant No', field: 'custNo', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 120
        },
        {
            headerName: 'Tenant Nationality', field: 'custNationality', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 150
        },
        {
            headerName: 'Tenant Email', field: 'custEmailId', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 200
        },
        {
            headerName: 'Tenant Contact No', field: 'custContactNo', filter: true, floatingFilter: true,
            valueFormatter: numberValueFormatter, suppressMovable: true, width: 150
        },
        {
            headerName: 'Owner Name', field: 'sellerName',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 200
        },
        {
            headerName: 'Owner Nationality', field: 'sellerNationality',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150
        },
        {
            headerName: 'Owner Email', field: 'sellerEmailId',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 200
        },
        {
            headerName: 'Owner Contact No', field: 'sellerContactNo',
            valueFormatter: numberValueFormatter, filter: true, floatingFilter: true, suppressMovable: true, width: 150
        },
    ]
    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            TanantName: [{ label: 'Select Tenant', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
            status: [{ label: 'All', value: '' }],
            periodFrom: '',
            periodto: '',
        });
        fetchDropdownData()
    }
    const handlePropertyChange = async (selectedOption) => {
        setUnitList(null)
        if (selectedOption?.value?.value === "All") {
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'DashboardUnitNosByPropertyId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('GET_DASHBOARD_CASCAD', `?${params.toString()}`);
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }]
            });
            setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
        }
    }
    const handleUitNo = async (selectedOption) => {
        setFormData({ ...formData, unitNo: selectedOption });
    }
    const handleMenuAction = (action, rowData) => {
        switch (action) {
            case 'createAgreement':
                handleCreateAgreement(rowData);
                break;
            case 'leaseReceipt':
                handleLeaseReceipt(rowData);
                break;
            case 'leaseStatement':
                handlePrint(rowData);
                break;
            case 'tenencyReport':
                handleTenencyReport(rowData);
                break;
            default:
                break;
        }
        setContextMenu(null); // Close the menu
    }
    const handlePrint = (rowData) => {
        if (rowData?.leaseNo) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REPORT_URL;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "reportName", value: "LSESTMT" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleTenencyReport = (rowData) => {
        if (rowData?.leaseNo) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase");
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REPORT_URL;
                form.target = "ReportPopup";

                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "reportName", value: "LATR" },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                ];
                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    return (
        <div className='p-3'>
            <div className="cost-center-section">
                <div className="d-flex mt-3 cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Parameters</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className='row'>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={proprtyList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col'>
                                <Select
                                    className="p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='col-3 d-flex gap-2'>
                                <div
                                    onClick={() => getItems()}
                                    className='mainbtnGry flex-end gap-2  w-50'>
                                    <FaFileCircleExclamation color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                <div
                                    onClick={() => handleClearFilters()}
                                    className='mainbtnRed flex-end gap-2 w-50'>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border-box2 p-4'>
                <div className='gridshad  mt-3'>
                    <div className="ag-theme-quartz" style={{ height: 600 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                if (params.node.rowIndex % 2 === 0) {
                                    return { background: '#F0EDF5' };
                                } else {
                                    return { background: '#fff' };
                                }
                            }}
                            rowData={rowData}
                            enableFilter={true}
                            floatingFilter={true}
                            columnDefs={columnDefs}
                            frameworkComponents={{ BtnCellRenderer }}
                            context={{ setContextMenu }}
                        />
                    </div>
                    <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={SearchItems} />
                </div>
            </div>
            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 10px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    {(() => {
                        const { unitStatus, leaseStatus } = contextMenu.data || {};

                        if (unitStatus === 'Available' && !leaseStatus) {
                            return (
                                <button className="btn btn-secondary" onClick={() => handleMenuAction('createAgreement', contextMenu.data)}>
                                    Create Lease Agreement
                                </button>
                            );
                        }
                        if (unitStatus === 'Leased' && leaseStatus === 'Active') {
                            return (
                                <div style={{ display: 'grid' }}>
                                    <button className="btn btn-secondary " onClick={() => handleMenuAction('leaseReceipt', contextMenu.data)}>
                                        Lease  Receipt
                                    </button>
                                    <button className="btn btn-secondary my-2" onClick={() => handleMenuAction('leaseStatement', contextMenu.data)}>
                                        Lease Statement
                                    </button>
                                    {/* <button className="btn btn-secondary " onClick={() => handleMenuAction('tenencyReport', contextMenu.data)}>
                                        Lease Tenancy Contract
                                    </button> */}
                                </div>
                            );
                        }
                        return <div>No actions available</div>;
                    })()}
                </div>
            )}

        </div>
    );
};
class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '25px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}

export default ListingDashBoard;